import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch} from "../../utils/Hooks";
import {getCategoryTypes} from "../../store/reducers/CategoryTypesSlice";
import {CategoryTypesTable} from "./components/CategoryTypesTable";

interface CategoryTypesScreenProps {
}

export const CategoryTypesScreen: React.FC<CategoryTypesScreenProps> = () => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getCategoryTypes());
    }, []);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Grupi tüübid</h1>
            <CategoryTypesTable />
        </LoggedInView>
    )

}